var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 12,
    viewBox: "0 0 10 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.5 0.5C5.5 0.223858 5.27615 0 5 0C4.72386 0 4.5 0.223858 4.5 0.5V10.197L0.871651 6.16552C0.686922 5.96026 0.370777 5.94362 0.165522 6.12835C-0.0397331 6.31308 -0.0563723 6.62923 0.128357 6.83448L4.62836 11.8345C4.72318 11.9398 4.85826 12 5 12C5.14175 12 5.27683 11.9398 5.37165 11.8345L9.87165 6.83448C10.0564 6.62923 10.0397 6.31308 9.83449 6.12835C9.62923 5.94362 9.31309 5.96026 9.12836 6.16552L5.5 10.197V0.5Z",
    fill: "#323130"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDown);
export default __webpack_public_path__ + "static/media/arrowDown.6a071b82b9f97a9e61ca93b4beb5dcad.svg";
export { ForwardRef as ReactComponent };